export class IsPayingCustomer {

    current: boolean = $derived.by(() => {
        return this.getHasActiveProVersion() || this.getHasActiveSubscription() || this.getHasActiveMobileSubscription()
    })

    constructor(
        private readonly getHasActiveProVersion: () => boolean,
        private readonly getHasActiveSubscription: () => boolean,
        private readonly getHasActiveMobileSubscription: () => boolean
    ) {
        // TODO refactor when upgraded to Svelte > 5.31 (+remove 'private readonly' modifier)
        // this.current = $derived(getHasActiveProVersion() || getHasActiveSubscription() || getHasActiveMobileSubscription());
    }
}